/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GdsIssFServ01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const gdsIssFServ01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsIssFServ01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const gdsIssFServ01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const gdsIssFServ01ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const gdsIssFServ01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const gdsIssFServ01FetchGdsIssFServ01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsIssFServ01FetchGdsIssFServ01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const gdsIssFServ01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const gdsIssFServ01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const gdsIssFServ01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const gdsIssFServ01ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_SHOW_SYNC_SETTING_LOADING]: gdsIssFServ01ShowSyncSettingLoading,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_SHOW_SYNC_SETTING_SUCCESS]: gdsIssFServ01ShowSyncSettingSuccess,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_SHOW_BATCH_JOB_STATUS_SUCCESS]: gdsIssFServ01ShowBatchJobStatusSuccess,

  [GdsIssFServ01Types.GDS_ISS_F_SERV01_RESET_TIMESTAMP]: gdsIssFServ01ResetTimestamp,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_FETCH_GDS_ISS_F_SERV01_LOADING]: gdsIssFServ01FetchGdsIssFServ01Loading,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_FETCH_GDS_ISS_F_SERV01_SUCCESS]: gdsIssFServ01FetchGdsIssFServ01Success,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_ADD_SELECTED_DOCUMENTS]: gdsIssFServ01AddSelectedDocuments,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_REMOVE_SELECTED_DOCUMENTS]: gdsIssFServ01RemoveSelectedDocuments,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_SET_WORKSPACE_VISIBLE]: gdsIssFServ01SetWorkspaceVisible,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_EXPORT_LOADING]: gdsIssFServ01ExportLoading,
  [GdsIssFServ01Types.GDS_ISS_F_SERV01_EXPORT_SUCCESS]: gdsIssFServ01ExportSuccess
});
